export enum LeagueEventType {
    MANDATORY = 1,
    BONUS = 2,
}

